export default __webpack_public_path__ + "static/media/kucoin-logo.225ca47c.svg";